export class Product {

    cover_image: string;

    constructor(public reference: string, public designation: string, public price: number) {

        
    }
}